import clsx from 'clsx'
import { useAuth } from 'contexts/auth'
import { useSidebar } from 'contexts/sidebar'
import { useInsightsEnabled } from 'hooks/use-insights-enabled'
import { IMenuOption } from 'layouts/default'
import SideBarItem from '../item'
import { BUYER_ICONS, SELLER_ICONS } from '../items'
import { useStyles } from './styles'

const SidebarDefault = () => {
  const { VITE_APP_AMBIENT } = import.meta.env
  const { expanded, expandedSubMenu, menuOptions, onCloseAll, onExpand, onExpandSub, onSelectSubMenuOption } =
    useSidebar()
  const { user } = useAuth()
  const { enabled: isInsightsEnabled } = useInsightsEnabled()
  const classes = useStyles()

  const handleExpand = () => onExpand()

  const handleMouseLeave = () => {
    if (!expandedSubMenu) {
      onCloseAll()
    }
  }

  const handleMouseEnterSubMenu = (id: string) => onSelectSubMenuOption(id)

  const handleMouseClickInSubMenu = (option: IMenuOption) => {
    if (option.route == '') {
      onExpandSub()
      onSelectSubMenuOption(option.id)
    }
  }

  return (
    <nav
      className={clsx(classes.root, { [classes.rootExpanded]: expanded })}
      onMouseEnter={handleExpand}
      onMouseLeave={handleMouseLeave}
    >
      <section>
        <header>
          {user &&
            user.isSeller &&
            SELLER_ICONS.map((option) => {
              if (VITE_APP_AMBIENT === 'prod' && option.notInProd) {
                return null
              }

              if (option.featureFlag === 'insights' && !isInsightsEnabled) {
                return null
              }

              return (
                <SideBarItem
                  key={option.idn}
                  idn={option.idn}
                  icon={option.icon}
                  label={option.label}
                  route={option.route}
                  workspace={option.workspace}
                />
              )
            })}

          {user &&
            !user.isSeller &&
            BUYER_ICONS.map((option) => {
              if (VITE_APP_AMBIENT === 'prod' && option.notInProd) {
                return null
              }

              if (option.featureFlag === 'insights' && !isInsightsEnabled) {
                return null
              }

              if (option.adminOnly && !user.isAdmin) {
                return null
              }

              return (
                <SideBarItem
                  key={option.idn}
                  idn={option.idn}
                  icon={option.icon}
                  label={option.label}
                  route={option.route}
                  workspace={option.workspace}
                />
              )
            })}
        </header>

        <main>
          {menuOptions?.length > 0 &&
            menuOptions.map((option) => {
              if (option.isOnlyApi || String(option.icon) == '') {
                return null
              }

              return (
                <div
                  key={option.id}
                  onMouseEnter={() => handleMouseEnterSubMenu(option.id)}
                  onClick={() => handleMouseClickInSubMenu(option)}
                >
                  <SideBarItem
                    key={option.id}
                    idn={option.id}
                    icon={option.icon}
                    route={option.route}
                    label={option.text}
                    direction={option.subMenuOptions && option.subMenuOptions.length > 0}
                  />
                </div>
              )
            })}
        </main>
      </section>
    </nav>
  )
}

export default SidebarDefault
